package org.lennycodes.hldi.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.components.EventCard
import org.lennycodes.hldi.components.GradientButton
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.data.Event
import org.lennycodes.hldi.layouts.MainLayout
import org.lennycodes.hldi.pages.admin.AdminRepository
import org.lennycodes.hldi.styles.AboutHeroSectionStyle
import org.lennycodes.hldi.styles.AboutHeroTextStyle
import org.lennycodes.hldi.styles.AboutHeroTitleStyle
import org.lennycodes.hldi.styles.SectionWaveSvg
import org.lennycodes.hldi.styles.SpinnerStyle


@Composable
@Page("/events")
fun EventsPage() {

    var isLoading by remember { mutableStateOf(true) }

    var events by remember {
        mutableStateOf<List<Event>>(emptyList())
    }


    LaunchedEffect(Unit) {

        try {

            events = AdminRepository.getAllEvents()

        } finally {

            isLoading = false

        }

    }


    MainLayout {


        // Hero Section
        Section(
            attrs = Modifier
                .padding(50.px, 20.px)
                .then(AboutHeroSectionStyle.toModifier())
                .toAttrs()
        ) {

            H1(
                attrs = AboutHeroTitleStyle.toAttrs()
            ) {

                Text("Upcoming Events")

            }


            P(
                attrs = AboutHeroTextStyle.toAttrs {
                    style {
                        maxWidth(700.px)
                    }
                }
            ) {

                Text(
                    "Join us at our upcoming events and be part of the change."
                )

            }


            SectionWaveSvg()

        }



        // Events List
        Section {


            Div(
                attrs = {

                    style {

                        maxWidth(1100.px)

                        margin(
                            24.px,
                            autoLength
                        )

                        padding(
                            10.px,
                            10.px,
                            0.px,
                            10.px
                        )

                        display(DisplayStyle.Flex)

                        flexDirection(
                            FlexDirection.Column
                        )

                        gap(24.px)

                    }

                }
            ) {


                when {


                    isLoading -> {


                        Div(

                            attrs = Modifier
                                .fillMaxWidth()
                                .padding(40.px)
                                .toAttrs {

                                    style {

                                        property(
                                            "display",
                                            "flex"
                                        )

                                        property(
                                            "justify-content",
                                            "center"
                                        )

                                        property(
                                            "align-items",
                                            "center"
                                        )

                                    }

                                }

                        ) {


                            Div(

                                attrs = Modifier
                                    .size(45.px)
                                    .then(
                                        SpinnerStyle.toModifier()
                                    )
                                    .toAttrs()

                            )


                        }


                    }



                    events.isEmpty() -> {


                        P(

                            attrs = {

                                style {

                                    textAlign(
                                        TextAlign.Center
                                    )

                                    fontSize(16.px)

                                    color(
                                        HLDITheme.Colors.mediumGray
                                    )

                                }

                            }

                        ) {

                            Text(
                                "No upcoming events available."
                            )

                        }


                    }



                    else -> {


                        events.forEach { event ->

                            EventCard(event)

                        }


                    }


                }


            }


        }




        // Calendar CTA
        Section(

            attrs = {

                style {

                    background(
                        "linear-gradient(135deg, ${HLDITheme.Colors.primary} 0%, ${HLDITheme.Colors.accent} 100%)"
                    )

                    borderRadius(16.px)

                    textAlign(
                        TextAlign.Center
                    )

                    padding(
                        60.px,
                        20.px
                    )

                    margin(32.px)

                }

            }

        ) {


            H2(

                attrs = {

                    style {

                        fontSize(28.px)

                        color(
                            HLDITheme.Colors.primary
                        )

                        marginBottom(16.px)

                        fontFamily(
                            "Playfair Display",
                            "serif"
                        )

                    }

                }

            ) {

                Text("Stay Updated")

            }



            P(

                attrs = {

                    style {

                        fontSize(16.px)

                        color(
                            HLDITheme.Colors.text
                        )

                        marginBottom(32.px)

                    }

                }

            ) {

                Text(
                    "Subscribe to our calendar to never miss an HLDI event."
                )

            }



            GradientButton(
                "Subscribe to Calendar",
                "#"
            )


        }


    }

}